"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("@insided/deprecated-preact-components/settings/common/utils");

var _SSIHeader = _interopRequireDefault(require("./SSIHeader"));

var _CustomHeader = _interopRequireDefault(require("./CustomHeader"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'header';
exports.cssAnchorName = cssAnchorName;

var HeaderComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HeaderComponent, _Component);

  var _super = _createSuper(HeaderComponent);

  function HeaderComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, HeaderComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      type: _this.props.type,
      defaultHeader: {
        logoUrl: _this.props.defaultHeaderLogoUrl,
        label: _this.props.defaultHeaderLabel,
        labelMobile: _this.props.defaultHeaderLabelMobile,
        url: _this.props.defaultHeaderUrl,
        backgroundColor: _this.props.defaultHeaderBackgroundColor,
        linkColor: _this.props.defaultHeaderLinkColor,
        cssVariables: {}
      },
      ssiHeader: {
        url: _this.props.ssiHeaderUrl,
        ssiHtml: _this.props.ssiHeaderHtml
      },
      customHeader: {
        html: _this.props.customHeaderHtml
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSSIHeaderHtml", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state, ssiHeader, type, ssiHeaderHtml, htmlWithUsernameAndAvatar;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, ssiHeader = _this$state.ssiHeader, type = _this$state.type;

              if (!(type === 'ssi' && ssiHeader.url && !ssiHeader.ssiHtml)) {
                _context.next = 12;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return (0, _utils.fetchServerSideHtml)(ssiHeader.url);

            case 5:
              ssiHeaderHtml = _context.sent;

              _this.setState(function (prevState) {
                return {
                  ssiHeader: _objectSpread(_objectSpread({}, prevState.ssiHeader), {}, {
                    ssiHtml: ssiHeaderHtml
                  })
                };
              });

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);

              _this.setState(function (prevState) {
                return {
                  ssiHeader: _objectSpread(_objectSpread({}, prevState.ssiHeader), {}, {
                    ssiHtml: "Error fetching server-side HTML: ".concat(_context.t0)
                  })
                };
              });

            case 12:
              if (_this.state.ssiHeader.ssiHtml) {
                htmlWithUsernameAndAvatar = _this.state.ssiHeader.ssiHtml.replace('{username}', _this.props.username).replace('{avatar}', _this.props.avatar);

                _this.setState(function (prevState) {
                  return {
                    ssiHeader: _objectSpread(_objectSpread({}, prevState.ssiHeader), {}, {
                      ssiHtml: htmlWithUsernameAndAvatar
                    })
                  };
                });
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleHeaderConfigChangeEvent", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(event) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (event instanceof CustomEvent && event.detail) {
                  _this.setState(event.detail.value, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return _this.setSSIHeaderHtml();

                          case 2:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })));
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleHeaderConfigResetEvent", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                type: _this.props.type,
                defaultHeader: {
                  logoUrl: _this.props.defaultHeaderLogoUrl,
                  label: _this.props.defaultHeaderLabel,
                  labelMobile: _this.props.defaultHeaderLabelMobile,
                  url: _this.props.defaultHeaderUrl,
                  backgroundColor: _this.props.defaultHeaderBackgroundColor,
                  linkColor: _this.props.defaultHeaderLinkColor,
                  cssVariables: {}
                },
                ssiHeader: {
                  url: _this.props.ssiHeaderUrl,
                  ssiHtml: _this.props.ssiHeaderHtml
                },
                customHeader: {
                  html: _this.props.customHeaderHtml
                }
              });

              _context4.next = 3;
              return _this.setSSIHeaderHtml();

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    return _this;
  }

  (0, _createClass2.default)(HeaderComponent, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setSSIHeaderHtml();

              case 2:
                window.addEventListener('headerConfigChange', this.handleHeaderConfigChangeEvent);
                window.addEventListener('headerConfigReset', this.handleHeaderConfigResetEvent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('headerConfigChange', this.handleHeaderConfigChangeEvent);
      window.removeEventListener('headerConfigReset', this.handleHeaderConfigResetEvent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          type = _this$state2.type,
          defaultHeader = _this$state2.defaultHeader,
          ssiHeader = _this$state2.ssiHeader,
          customHeader = _this$state2.customHeader;

      if (type === 'default') {
        var hasOuterLink = defaultHeader.label && defaultHeader.url;
        var hasOuterLinkOnMobile = defaultHeader.labelMobile && defaultHeader.url;
        return (0, _preact.h)("div", {
          className: (0, _classnames.default)(['ssi', 'ssi-header', 'custom-header'])
        }, (0, _preact.h)("section", {
          className: "full-width Template-brand-header"
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)(['brand-navigation-wrapper', 'qa-brand-navigation', 'p-v']),
          style: {
            background: defaultHeader.backgroundColor
          }
        }, (0, _preact.h)("div", {
          className: "sitewidth"
        }, (0, _preact.h)("div", {
          className: "col"
        }, (0, _preact.h)("div", {
          className: "brand-navigation-container"
        }, (0, _preact.h)("div", {
          className: "brand-logo-container"
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/"),
          target: "_self",
          className: (0, _classnames.default)(['brand-logo', 'brand--logo-anchor', 'pull-left'])
        }, defaultHeader.logoUrl && (0, _preact.h)("img", {
          src: (0, _absoluteUrlRuntime.resolveUrl)(defaultHeader.logoUrl || "/static/images/brand_logo.svg"),
          alt: "Customer Logo"
        }))), (0, _preact.h)("div", {
          className: "brand-url-container"
        }, hasOuterLink && (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(defaultHeader.url),
          style: {
            color: defaultHeader.linkColor
          },
          className: (0, _classnames.default)(['brand-external-url', 'link', 'link--light', 'pull-right', 'is-hidden-M']),
          target: "_blank",
          rel: "noreferrer"
        }, defaultHeader.label, (0, _preact.h)("span", {
          className: (0, _classnames.default)(['icon', 'icon--caret-right', 'icon--auto-width']),
          "aria-hidden": "true"
        })), hasOuterLinkOnMobile && (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(defaultHeader.url),
          style: {
            color: defaultHeader.linkColor
          },
          className: (0, _classnames.default)(['brand-external-url', 'link', 'link--light', 'pull-right', 'is-hidden-L']),
          target: "_blank",
          rel: "noreferrer"
        }, defaultHeader.labelMobile, (0, _preact.h)("span", {
          className: (0, _classnames.default)(['icon', 'icon--caret-right', 'icon--auto-width']),
          "aria-hidden": "true"
        })))))))));
      } else if (type === 'ssi' && ssiHeader.url) {
        return (0, _preact.h)(_SSIHeader.default, {
          url: ssiHeader.url,
          initialHtml: ssiHeader.ssiHtml,
          html: ssiHeader.ssiHtml,
          username: this.props.username,
          avatar: this.props.avatar
        });
      } else if (type === 'custom' && customHeader) {
        return (0, _preact.h)(_CustomHeader.default, {
          html: customHeader.html
        });
      } else {
        return null;
      }
    }
  }]);
  return HeaderComponent;
}(_preact.Component);

var _default = HeaderComponent;
exports.default = _default;